module.exports = require("./db.json");